import React from "react";
import styles from "./ChatTips.module.scss";
export function ChatTips(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.plainText
  }, "Please speak to a professional for medical, legal, or financial advice. "), /*#__PURE__*/React.createElement("div", {
    className: styles.linkText,
    onClick: function onClick() {
      return props.onLinkClicked();
    }
  }, "Read our full disclaimer."));
}